/**
 * Oembed element wrapper, which helps with targeting it in the DOM
 *
 * @param {boolean} [enableDebug=false] - Enable debugging output
 */
export default (enableDebug = false) => {
	const debug = enableDebug;

	// Find all iframe elements with src containing "YouTube.com," "youtu.be," or "vimeo.com"
	const videoIframes = document.querySelectorAll('iframe[src*="youtube.com"], iframe[src*="youtu.be"], iframe[src*="vimeo.com"]');
	if (debug) console.log(videoIframes);

	// Loop through each found iframe and wrap them in a div
	videoIframes.forEach((iframe) => {
		if (debug) console.log('Found an oEmbed, wrapping it with custom <div> ...');

		// Create a div element
		const wrapperDiv = document.createElement('div');

		// Add a class to the div
		wrapperDiv.classList.add('embed', 'embed--16by9');

		// Replace the iframe with the div
		iframe.parentNode.replaceChild(wrapperDiv, iframe);

		// Append the iframe to the div
		wrapperDiv.appendChild(iframe);
	});
};
